import React,{useEffect} from 'react'
import {Link} from 'react-router-dom'
import Paromain from '../Assets/Images/plogo.png'


const ParodashboardMain = () => {


  useEffect(()=>{

    document.getElementById("ParousernameD").innerHTML=localStorage.getItem('username')
    

  });

  
  return (

    <>
    <div className='Paro-addmain'>
 {/* <div className="Paro-addgrid-layout"> 
    <div className="Paro-addmain-top">
        <div className='Paro-addmain-back'>
           <Link to='/ParoSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>
           Welcome!!!!!!
           </span>
 

     </div>
 </div>  */}





    
    <script src="main.js"></script>
    <a class="youtube" 
    
       id="parospan">
        Welcome To &nbsp;<span> Paropakari</span>&nbsp;
      <img src={Paromain} id="Parologo"></img>&nbsp;
      '<span id="ParousernameD"></span>'</a>
      
   
    </div>
    </>
    
  )
}

export default ParodashboardMain